<template>
    <div
        class="challenge-leaderboard-list-item"
        :class="currentUserClass">
        <span class="challenge-leaderboard-list-item__rank">{{ leaderboardItem.rank }}</span>
        <div class="challenge-leaderboard-list-item__wr-user-img">
            <img class="challenge-leaderboard-list-item__user-img" :src="userImageLink">
            <span class="challenge-leaderboard-list-item__user-img-shadow"></span>
        </div>
        <span class="challenge-leaderboard-list-item__username">{{ username }}</span>
        <div class="challenge-leaderboard-list-item__stat-loss">
            <span class="challenge-leaderboard-list-item__stat-loss-icon"></span>
            <span class="challenge-leaderboard-list-item__stat-loss-value">{{ leaderboardItem.stats.loss }}</span>
        </div>
        <div class="challenge-leaderboard-list-item__stat-win">
            <span class="challenge-leaderboard-list-item__stat-win-icon"></span>
            <span class="challenge-leaderboard-list-item__stat-win-value">{{ leaderboardItem.stats.win }}</span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            leaderboardItem: {
                type: Object,
                default: {
                    id: 5,
                    username: "seslana",
                    rank: 4,
                    stats: {
                        win: 17,
                        loss: 12
                    }
                }
            },
        },

        computed: {
            userImageLink(){
                // return this.$store.state.api.img + this.leaderboardItem.id + '.jpg';
                return this.$store.state.api.getImage + this.leaderboardItem.id;
            },

            username(){
                let userSession = this.$store.state.userSession;
                return this.leaderboardItem.id === userSession.id
                       ? 'sen'
                       : this.leaderboardItem.username;
            },

            currentUserClass(){
                let userSession = this.$store.state.userSession;
                if(this.leaderboardItem.id !== userSession.id){
                    return '';
                }
                else if(this.leaderboardItem.rank === 4){
                    return 'challenge-leaderboard-list-item--current-user-border-bot'
                }
                else if(this.leaderboardItem.rank > 4 && this.leaderboardItem.rank <= 9){
                    return 'challenge-leaderboard-list-item--current-user-border-top-bot';
                }
                else if(this.leaderboardItem.rank >= 10){
                    return 'challenge-leaderboard-list-item--current-user-border-top';
                }
            }
        }
    };
</script>
<style scoped src="@/css/components/challenge-leaderboard-list-item.css"></style>